import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from "moment";
import _ from "lodash";
import {
	actionDeleteEmpresa,
	actionChangeEmpresaProps,
	actionGetEmpresasList,
	actionUpdateEmpresa
} from "../../actions/EmpresaActions";
import download from "downloadjs";
import {
	actionGenerateExcel,
	actionGenerateExcelCompaniesNotRegistered
} from "../../actions/GenerateExcelActions";
import {
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn
} from "material-ui/Table";
import {
	EMPRESAS_NEW,
	EMPRESAS_EDIT,
	INDEX,
	EMPRESA_MOVEMENTS
} from "../../config/RoutesConstants";
import {
	MODE_CRU_CREATE,
	MODE_CRU_UPDATE,
	MODE_CRU_SHOW
} from "../../actions/ActionConstants";
import {
	ROL_ADMIN,
	ROL_EMPRESA,
	ROL_OPERADOR_RECAUDA,
	ROL_SUB_ADMIN,
	ROL_COORDINADOR,
	ROL_OPERADOR_AFFI
} from "../../common/Constants";
import { change } from "redux-form";
import { Card, CardTitle, CardText } from "material-ui/Card";
import Util, { SUCCESS, ERROR, WARNING } from "../../common/Util";
import AppMem from "../../common/AppMem";
import OptionsTableRowColumn from "../../components/OptionsTableRowColumn/OptionsTableRowColumn";
import FilterCard from "../../components/FilterCard/FilterCard";
import Paginator from "../../components/Paginator/Paginator";
let limitePagina = 10;

class EmpresasIndex extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchFieldValue: "",
			login: this.props.login,
			rol: this.props.rol,
			itemsList: [],
			empresasList: !_.isEmpty(this.props.empresasList)
				? this.props.empresasList.splice(0, this.props.empresasList.length)
				: []
		};
		this.onToggleActiveEmpresa = this.onToggleActiveEmpresa.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.onCreateOrUpdate = this.onCreateOrUpdate.bind(this);
		this.onGenerateExcel = this.onGenerateExcel.bind(this);
		this.onTapConfirmDelete = this.onTapConfirmDelete.bind(this);
		this.getEmpresas = this.getEmpresas.bind(this);
		this.onChangePage = this.onChangePage.bind(this);
		this.onChangeSearch = this.onChangeSearch.bind(this);
		this.handleKeyPressSearchInput = this.handleKeyPressSearchInput.bind(this);
		this.ShowHideFilterCard = this.ShowHideFilterCard.bind(this);
		this.onChangeActiveEmpresa = this.onChangeActiveEmpresa.bind(this);
		this.renderBodyRows = this.renderBodyRows.bind(this);
		this.checkRol = this.checkRol.bind(this);
		this.renderPaginator = this.renderPaginator.bind(this);
		this.handleShowMovements = this.handleShowMovements.bind(this);
	}
	componentWillMount() {
		if (this.props.rol === ROL_EMPRESA) this.props.history.push(INDEX);
		if (this.props.rol === ROL_ADMIN) this.getEmpresas(1, limitePagina);
	}
	componentWillReceiveProps(nextProps) {
		if (this.props.rol !== nextProps.rol && nextProps.rol === ROL_EMPRESA) {
			this.props.history.push(INDEX);
		}
	}
	getEmpresas(page, limit) {
		let { searchtext } = this.props;
		if (
			(searchtext === "" || searchtext === " ") &&
			this.props.rol !== ROL_ADMIN
		)
			Util.showNoty(WARNING, "Ingrese algún criterio de búsqueda.");
		else this.props.actionGetEmpresasList(searchtext, page, limit);
	}

	renderPaginator() {
		return (
			<Paginator
				page={this.props.page}
				pageLimit={limitePagina}
				total={this.props.total}
				onChangePage={this.onChangePage}
			/>
		);
	}

	onChangeSearch({ target: { value } }) {
		this.props.actionChangeEmpresaProps({ searchtext: value });
	}

	handleKeyPressSearchInput(e) {
		if (e.key === "Enter") {
			this.handleSearch();
		}
	}

	handleSearch() {
		let activeFilters = false;
		//TODO
		// if (
		// 	this.props.vigenciaDesde !== null ||
		// 	this.props.vigenciaHasta !== null ||
		// 	this.props.activa !== 0
		// ) {
		// 	activeFilters = true;
		// }
		this.props.actionChangeEmpresaProps({
			page: 1,
			activeFilters: activeFilters
		});
		this.getEmpresas(1, limitePagina);
	}

	onCreateOrUpdate(empresa) {
		if (empresa) {
			this.props.actionChangeEmpresaProps({
				empresa: empresa,
				modeCRU: MODE_CRU_UPDATE,
				searchtext: ""
			});
			this.props.history.push(EMPRESAS_EDIT);
		} else {
			this.props.actionChangeEmpresaProps({
				empresa: null,
				modeCRU: MODE_CRU_CREATE,
				searchtext: ""
			});
			this.props.history.push(EMPRESAS_NEW);
		}
	}
	onGenerateExcel(registered) {
		if (registered)
			this.props.actionGenerateExcel(
				"empresa",
				null,
				null,
				this.returnDownload.bind(this)
			);
		else
			this.props.actionGenerateExcelCompaniesNotRegistered(
				this.returnDownloadNotRegistered.bind(this)
			);
	}

	returnDownload(type, blob) {
		let fechaActual = moment().format("DD-MM-YYYY");
		let nombreArchivo = "Empresas - " + fechaActual;
		download(blob, nombreArchivo);
	}

	returnDownloadNotRegistered(blob) {
		let fechaActual = moment().format("DD-MM-YYYY");
		let nombreArchivo = "Empresas No Registradas - " + fechaActual;
		download(blob, nombreArchivo);
	}

	ShowHideFilterCard() {
		let showFilterCard = this.state.showFilterCard;
		this.setState({
			showFilterCard: !showFilterCard
		});
	}

	onChangeActiveEmpresa(event, index, value) {
		this.props.actionChangeEmpresaProps({ activa: value });
	}

	returnFormatDate(date) {
		return Util.formatDateToShow(date);
	}

	handleDelete(empresa) {
		AppMem.confirmDialog.open({
			title: "Eliminar Empresa",
			messageConfirm:
				"¿Esta seguro que desea eliminar empresa" + empresa.name + "?",
			onAccept: this.onTapConfirmDelete.bind(this, empresa._id)
		});
	}

	handleShow(empresa) {
		this.props.actionChangeEmpresaProps({
			modeCRU: MODE_CRU_SHOW,
			empresa: empresa
		});
		this.props.history.push(EMPRESAS_EDIT);
	}
	handleShowMovements(empresa) {
		this.props.actionChangeEmpresaProps({
			modeCRU: MODE_CRU_SHOW,
			empresa: empresa
		});
		this.props.history.push(EMPRESA_MOVEMENTS);
	}

	onTapConfirmDelete(empresaId) {
		this.props.actionDeleteEmpresa(
			empresaId,
			this.returnConfirmDelete.bind(this)
		);
	}

	returnConfirmDelete(response) {
		if (response === SUCCESS) {
			this.getEmpresas(this.props.page, limitePagina);
			Util.showNoty(response, "Empresa eliminada exitosamente");
		} else if (response === ERROR) {
			Util.showNoty(response, "Error al eliminar empresa");
		} else {
			Util.showNoty(
				response,
				"No se puede eliminar empresa, tiene elementos asociados"
			);
		}
	}

	renderBlank() {
		let mensaje = "";
		if (this.props.busquedaRealizada) {
			mensaje = "No se encontraron resultados";
		} else {
			mensaje = "Aplique un criterio de búsqueda para visualizar datos";
		}
		return (
			<TableRow key={1}>
				<TableRowColumn>
					<p>{mensaje}</p>
				</TableRowColumn>
			</TableRow>
		);
	}

	onChangePage(page) {
		this.props.actionChangeEmpresaProps({
			page: page
		});
		this.getEmpresas(page, limitePagina);
	}

	dispatchOnChange(field, value) {
		this.props.dispatch(change("EmpresasIndex", field, value));
	}

	onToggleActiveEmpresa(empresaId, checked) {
		checked = { active: checked };
		this.props.actionUpdateEmpresa(empresaId, checked, this.returnToggle);
	}

	returnToggle(response) {
		if (response === SUCCESS) {
			Util.showNoty(SUCCESS, "Empresa modificado exitosamente");
		} else if (response === ERROR) {
			Util.showNoty(ERROR, "Error al modificar empresa");
		}
	}

	renderBodyRows(empresasList, activeButton) {
		let Edit = this.onCreateOrUpdate;
		const Show = this.handleShow;
		const ShowMovements = this.handleShowMovements;
		const rol = this.props.rol;
		return _.map(empresasList, (empresa, i) => {
			if (rol !== "solo lectura") {
				return (
					<TableRow key={i} style={{ height: "16px", fontSize: "12px" }}>
						<TableRowColumn style={{ marginLeft: 15 }}>
							{empresa.name}
						</TableRowColumn>
						<TableRowColumn style={{ marginLeft: 20 }}>
							{empresa.cuit}
						</TableRowColumn>

						<TableRowColumn style={{ marginLeft: 20 }}>
							{empresa.email}
						</TableRowColumn>
						<TableRowColumn style={{ marginLeft: 20 }}>
							{empresa.state}
						</TableRowColumn>
						<TableRowColumn style={{ width: "20%" }}>
							{this.props.rol === ROL_OPERADOR_RECAUDA ? (
								<OptionsTableRowColumn
									activeButton={activeButton}
									handleShow={() => Show(empresa)}
									handleEdit={() => Edit(empresa)}
									showTooltip="Mostrar"
								/>
							) : this.props.rol === ROL_ADMIN ||
							this.props.rol === ROL_SUB_ADMIN ||
							this.props.rol === ROL_COORDINADOR ? (
								<OptionsTableRowColumn
									activeButton={activeButton}
									handleEdit={() => Edit(empresa)}
									showTooltip="Editar"
									handleEditPayment={() => ShowMovements(empresa)}
									showEditPayment={"Cuenta Corriente"}
								/>
							) : this.props.rol === ROL_OPERADOR_AFFI ? (
								<OptionsTableRowColumn
									activeButton={activeButton}
									handleShow={() => Show(empresa)}
									showTooltip="Mostrar"
								/>
							) : null}
						</TableRowColumn>
					</TableRow>
				);
			} else {
				return (
					<TableRow key={i} style={{ height: "16px", fontSize: "12px" }}>
						<TableRowColumn style={{ marginLeft: 15 }}>
							{empresa.name}
						</TableRowColumn>
						<TableRowColumn>{}</TableRowColumn>
						<TableRowColumn style={{ marginLeft: 20 }}>
							{empresa.cuit}
						</TableRowColumn>

						<TableRowColumn style={{ marginLeft: 20 }}>
							{empresa.email}
						</TableRowColumn>
						<TableRowColumn style={{ width: "20%" }}>
							<OptionsTableRowColumn
								activeButton={activeButton}
								// handleShow={() => Show(item)}
							/>
						</TableRowColumn>
					</TableRow>
				);
			}
		});
	}

	checkRol(rol) {
		if (rol !== "solo lectura") {
			return this.onCreateOrUpdate();
		}
	}

	// handleChange = (event, index, value) => this.setState({ value });

	render() {
		return (
			<div className="center">
				<Card className="card">
					<CardTitle
						title="Empresas"
						subtitle="Agregue o modifique Empresas para UPSRA"
					/>
					<CardText>
						{this.props.rol === ROL_ADMIN ? (
							<FilterCard
								onChangeSearchField={this.onChangeSearch}
								InputValue={this.props.searchtext}
								onKeyPressSearchField={this.handleKeyPressSearchInput}
								labelSearchInput={"Buscar por Nombre o CUIT"}
								onTouchTapSearch={() =>
									this.handleSearch(this.props.searchtext)
								}
								onTouchTapNew={() => this.onCreateOrUpdate()}
								onTouchGenerateExcel={() => this.onGenerateExcel(true)}
								generateExcelLabel={"Generar Excel Empresas Registradas"}
								onTouchGenerateExcelDDJJConcepts={() =>
									this.onGenerateExcel(false)
								}
								generateExcelLabelDDJJConcepts="Generar Excel Empresas No Registradas"
							/>
						) : (
							<FilterCard
								onChangeSearchField={this.onChangeSearch}
								InputValue={this.props.searchtext}
								onKeyPressSearchField={this.handleKeyPressSearchInput}
								labelSearchInput={"Buscar por Nombre o CUIT"}
								onTouchTapSearch={() =>
									this.handleSearch(this.props.searchtext)
								}
							/>
						)}

						<Table selectable={false}>
							<TableHeader displaySelectAll={false}>
								<TableRow>
									<TableHeaderColumn>Empresa</TableHeaderColumn>
									<TableHeaderColumn>Cuit</TableHeaderColumn>
									<TableHeaderColumn>Email</TableHeaderColumn>
									<TableHeaderColumn>Estado</TableHeaderColumn>
									<TableHeaderColumn style={{ width: "20%" }}>
										Acciones
									</TableHeaderColumn>
								</TableRow>
							</TableHeader>
							<TableBody stripedRows displayRowCheckbox={false}>
								{!_.isEmpty(this.props.empresasList)
									? this.renderBodyRows(
											this.props.empresasList,
											this.state.rol === "solo lectura"
									  )
									: this.renderBlank()}
							</TableBody>
						</Table>
					</CardText>
					{!_.isEmpty(this.props.empresasList) ? this.renderPaginator() : ""}
				</Card>
			</div>
		);
	}
}

function mapStateToProps(store) {
	return {
		searchtext: store.empresa.searchtext,
		empresasList: store.empresa.empresasList,
		loadingText: store.empresa.loadingText,
		busquedaRealizada: store.empresa.busquedaRealizada,
		activeFilters: store.empresa.activeFilters,
		modeCRU: store.empresa.modeCRU,
		page: store.empresa.page,
		login: store.session.authenticated,
		rol: store.app.rol,
		total: store.empresa.total
	};
}
function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			actionDeleteEmpresa,
			actionChangeEmpresaProps,
			actionGetEmpresasList,
			actionUpdateEmpresa,
			actionGenerateExcel,
			actionGenerateExcelCompaniesNotRegistered
		},
		dispatch
	);
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(EmpresasIndex);



// WEBPACK FOOTER //
// ./src/screens/Empresa/EmpresaIndex.js